import clsx from 'clsx'
import type { FC } from 'react'
import React from 'react'

import Delete from '@/assets/img/delete-icon.svg?react'
import DotsSvg from '@/assets/img/dots.svg?react'
import Edit from '@/assets/img/edit-pan.svg?react'
import Dropdown from '@/compoments/common/Dropdown'
import DropdownList from '@/compoments/DropdownList'
import AddNotificationModal from '@/compoments/modals/AddNotificationModal/AddNotificationModal'
import useModal from '@/hooks/useModal'
import { useDeleteNotificationMutation } from '@/services/notifications/notifications'
import { ROLE_LABELS, type UserRoleEnum } from '@/types'
import type { INotification, ScheduleType } from '@/types/notifications'

const scheduleOptions: Record<ScheduleType, string> = {
    immediate: 'At the time of the event',
    delayed: 'Delayed',
    specific_time: 'Specific Time',
}

interface INotificationItemProps {
    notification: INotification
}

export const NotificationItem: FC<INotificationItemProps> = ({
    notification,
}) => {
    const { isOpen, closeModal, openModal } = useModal()
    const [deleteNotification] = useDeleteNotificationMutation()

    return (
        <tr key={notification.id}>
            <td>{notification.event.name}</td>
            <td>
                <span className="text-color-1">
                    {scheduleOptions[notification.schedule as ScheduleType]}
                </span>
            </td>
            <td>
                {notification?.target.includes('all') ? (
                    <span>All Users</span>
                ) : (
                    notification?.target?.map((role, index) => (
                        <span key={index} className="inline-block p-1">
                            {ROLE_LABELS[role as UserRoleEnum] || role}
                        </span>
                    ))
                )}
            </td>
            <td>
                <span
                    className={clsx('pill capitalize', {
                        'pill-danger': notification?.status === 'failed',
                        'pill-success': notification.status === 'sent',
                        'pill-pending': notification.status === 'pending',
                    })}
                >
                    {notification.status}
                </span>
            </td>
            <td className="text-right sticky-end">
                <Dropdown
                    closeSelf={true}
                    dropdownClasses="flex flex-col"
                    button={
                        <span className="ico">
                            <DotsSvg />
                        </span>
                    }
                    menuClassName="dropdown-md"
                    menu={
                        <DropdownList
                            list={[
                                {
                                    title: 'Edit',
                                    icon: <Edit />,
                                    action: () => openModal('add-notification'),
                                },
                                {
                                    title: 'Delete',
                                    icon: <Delete />,
                                    action: async () =>
                                        deleteNotification(notification.id),
                                    type: 'btn-drp-link-danger',
                                },
                            ]}
                        />
                    }
                />
            </td>
            {isOpen('add-notification') && (
                <AddNotificationModal
                    isOpen={isOpen('add-notification')}
                    onClose={() => closeModal('add-notification')}
                    notificationId={notification.id}
                />
            )}
        </tr>
    )
}
